// import { useState } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import TextForm from './components/TextForm';
// import About from './components/About';
import React, { useState } from 'react'
import Alert from './components/Alert';

// import { Routes, Route, Link } from "react-router-dom";

// import { Routes ,Route } from 'react-router-dom';
// import { Router, Link } from "react-router-dom";


function App() {
  const [mode, setMode] = useState('light');
  const [alert, setAlert] = useState(null);

  const showAlert = (message, typeee) => {
    setAlert({
      msg: message,
      type: typeee
    })

    setTimeout(() => {
      setAlert(null);
    },1500);
  }

  const toggleMode1 = () => {
    if (mode === 'light') {
      setMode('dark');
      document.body.style.backgroundColor = '#042743';
      showAlert("Dark Mode has been enabled", "success");
    }
    else {
      setMode('light');
      document.body.style.backgroundColor = 'white';
      showAlert("Light Mode has been enabled", "success");
    }
  }
  // const toggleMode2 = () => {
  //   if (mode === 'light') {
  //     setMode('dark');
  //     document.body.style.backgroundColor = '#730808';
  //     showAlert("Dark Mode has been enabled", "success");
  //   }
  //   else {
  //     setMode('light');
  //     document.body.style.backgroundColor = 'white';
  //     showAlert("Light Mode has been enabled", "success");
  //   }
  // }
  return (
    <>
      {/* <Router> */}
        {/* <Navbar title="TextOperations" about="About Us" /> */}

        {/* <Navbar title="TextOperations" mode={mode} toggleMode1={toggleMode1} toggleMode2={toggleMode2} /> */}
        
        <Navbar title="TextOperations" mode={mode} toggleMode1={toggleMode1}  />

        <Alert alert={alert} />


        {/* my-3 means Margin in y-Axis 3px */}
        <div className="container my-3" >

          {/* <Routes> */}
            {/* <Route path="/about"> */}
              {/* <About mode={mode} /> */}
            {/* </Route> */}
            {/* <Route path="/"> */}

              <TextForm showAlert={showAlert} heading="Welcome to TextOperations!" mode={mode} />

            {/* </Route> */}
          {/* </Routes> */}

        </div>

      {/* </Router> */}
    </>
  );
}

export default App;
